'use client'

import { FC, useMemo } from "react";

import promoImgOne from "@/assets/webp/promo-1.webp";
import promoImgTwo from "@/assets/webp/promo-2.webp";
import promoImgOneMob from "@/assets/webp/promo-1-mob.webp";
import promoImgTwoMob from "@/assets/webp/promo-2-mob.webp";
import { Box } from "./styles";
import { Card, CardType } from "./Card";
import { useTranslations } from "next-intl";

import { Container, Wrapper } from "@/features/pages/home";

const PROMO_CARDS = (t: (s: string) => string): CardType[] => [
  {
    imgDesktop: promoImgOne.src,
    imgMobile: promoImgOneMob.src,
    title: {
      text: t("promo.calcTitle"),
      color: "blue-dark",
    },
    desc: t("promo.calcDesc"),
    button: {
      text: t("promo.calcButton"),
      color: "black",
      borderColor: "orange",
    },
  },
  {
    imgDesktop: promoImgTwo.src,
    imgMobile: promoImgTwoMob.src,
    title: {
      text: t("promo.agentTitle"),
      color: "orange",
    },
    desc: t("promo.agentDesc"),
    button: {
      text: t("promo.agentButton"),
      color: "orange",
      borderColor: "blue-dark",
    },
  },
];

export const Promo: FC = () => {
  const t = useTranslations();

  const promoData = useMemo(() => PROMO_CARDS(t), [t]);

  return (
    <Wrapper $bgColor="beige-dove">
      <Container>
        <Box>{promoData?.map((e, i) => <Card key={i} data={e} />)}</Box>
      </Container>
    </Wrapper>
  );
};
